export { DefaultPrivacyLevel, TraceContextInjection, isSampleRate, validateAndBuildConfiguration, serializeConfiguration, } from './configuration';
export { createEndpointBuilder, buildEndpointHost } from './endpointBuilder';
export { computeTransportConfiguration, isIntakeUrl } from './transportConfiguration';
export { buildTags, buildTag, sanitizeTag } from './tags';
//# sourceMappingURL=index.js.map